import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowShareRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowShareRight"><Path d="M22.5 12L12.5 3.5V8.5C4 8.5 1.5 12 1.5 20.5C3 17.5 4 15.5 12.5 15.5V20.5L22.5 12Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconArrowShareRight;
